export default "__VITE_ASSET__C9oLTC$a__"